import { URLS } from '@assets/environment/urls'
import { SearchParams } from '@shared/types/searchParams'
import { AxiosResponse } from 'axios'
import { Exercise } from '@entities/exercise'
import { PaginationResult } from '@shared/types/pagination'
import { authAxios } from '@shared/api/auth-instance'
import { Language } from '@shared/types/language'
import { getCurrentBackendLocale } from '@shared/i18n'

export class ExerciseProxy {
	static BASE_URL: string = URLS.WORKOUT + 'exercises/'

	static search = async (
		params: SearchParams,
		language: Language = getCurrentBackendLocale()
	): Promise<PaginationResult<Exercise>> => {
		const urlParams = new URLSearchParams()
		urlParams.set('language', language)

		try {
			const exercises: AxiosResponse<PaginationResult<Exercise>> = await authAxios.post(
				ExerciseProxy.BASE_URL + 'search',
				params,
				{ params: urlParams }
			)
			return exercises.data
		} catch (e: unknown) {
			console.error(e)
			return { results: 0, page: 0, rows: [], warnings: null }
		}
	}

	static FtsSearch = async (
		params: SearchParams,
		term: string,
		lang: Language = getCurrentBackendLocale()
	): Promise<PaginationResult<Exercise>> => {
		const searchParams = new URLSearchParams()
		searchParams.set('term', term)
		searchParams.set('lang', lang)
		try {
			const exercises = await authAxios.post(ExerciseProxy.BASE_URL + 'search-fts', params, {
				params: searchParams,
			})
			return exercises.data
		} catch (e: unknown) {
			console.error(e)
			return { results: 0, page: 0, rows: [], warnings: null }
		}
	}
}
